import { TripCartPrice } from 'src/common/types/TripCartPrice';

const RENTER_SECTION_ID = 'renter-trip';
const FARE_GROUP_ID = 'renter-fare-payment';
const BASE_COST_LINE_ID = 'renter-fare-payment-rental-subtotal';

const getBaseCostFromPriceSections = (data: TripCartPrice): number | null => {
  const renterSection = data.price_sections?.find((section) => section.id === RENTER_SECTION_ID)
    ?? data.price_sections?.[0];
  const fareGroup = renterSection?.price_groups?.find((group) => group.id === FARE_GROUP_ID);
  const baseCostLine = fareGroup?.price_lines?.find(
    (line) => line.id === BASE_COST_LINE_ID,
  );
  return baseCostLine?.unformatted_amount ?? null;
};

export default getBaseCostFromPriceSections;
